export default "/images/f61189002eee0347e0910cde7bc59da7.avif";